import { render, staticRenderFns } from "./XmTipDialog.vue?vue&type=template&id=4a3b128d&scoped=true"
import script from "./XmTipDialog.vue?vue&type=script&lang=js"
export * from "./XmTipDialog.vue?vue&type=script&lang=js"
import style0 from "./XmTipDialog.vue?vue&type=style&index=0&id=4a3b128d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3b128d",
  null
  
)

export default component.exports